import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Checkbox, FormControlLabel } from '@mui/material';

import { ControlledTextField } from 'components/shared/ControlledFields';

import { FORCE_SALARY_EXPORT } from '../HoursCorrectionDialog/correctionSpec.types';
import { MemoRow } from '../../EmploymentHours.styles';

type Props = {
  canEdit: boolean;
};

/**
 * The two corrections that are not a number, so no value column can hold them: the memo and the
 * salary-export trigger. Everything else the old correction form carried now sits beside the value it
 * corrects, in the blocks above.
 */
const MemoAndSalaryTrigger = ({ canEdit }: Props) => {
  'use memo';

  const { t } = useTranslation('common', {
    keyPrefix: 'employmentHours.corrections'
  });
  const { control } = useFormContext();

  return (
    <MemoRow>
      <ControlledTextField
        name="inputWorkingMemo"
        control={control}
        variant="outlined"
        label={t('memoSection')}
        disabled={!canEdit}
        multiline
        rows={3}
      />
      <Controller
        name="flags"
        control={control}
        render={({ field }) => (
          <FormControlLabel
            label={t('forceSalaryExport')}
            disabled={!canEdit}
            control={
              <Checkbox
                checked={field.value?.includes(FORCE_SALARY_EXPORT) ?? false}
                // Controller's onChange marks the form dirty; the shared ControlledFlagCheckbox uses
                // setValue without shouldDirty, so the arrows' isDirty guard would miss this field
                onChange={(event) =>
                  field.onChange(
                    event.target.checked
                      ? [...(field.value ?? []), FORCE_SALARY_EXPORT]
                      : (field.value ?? []).filter(
                          (flag: string) => flag !== FORCE_SALARY_EXPORT
                        )
                  )
                }
              />
            }
          />
        )}
      />
    </MemoRow>
  );
};

export default MemoAndSalaryTrigger;
